import { useTranslation } from "react-i18next";

import { formatPrice } from "utils/formatPrice";

import type { VATGroup } from "utils/common";

interface RepairOverviewInterventionPriceProps {
  totalFixedSelectedPriceInterventions: string;
  showVat?: boolean;
  vatGroups?: VATGroup[];
}

export const RepairOverviewInterventionPrice = ({ totalFixedSelectedPriceInterventions, showVat, vatGroups }: RepairOverviewInterventionPriceProps) => {
  const { t } = useTranslation();

  const multipleVatRates = vatGroups && vatGroups.length > 1;
  const filteredVatGroups = vatGroups?.filter(group => group.rate > 0 && group.amount > 0) ?? [];

  return (
    <div className="total-amount-container">
      {showVat &&
        multipleVatRates &&
        filteredVatGroups.map(group => (
          <div key={group.rate} className="float-right">
            <p>
              {t("v8_vat", "VAT")} {group.rate}%: <strong>€ {formatPrice(group.amount)}</strong>
            </p>
          </div>
        ))}
      <div className="float-right">
        <p>
          {t("v8_fixed_and_selected", "Fixed & Selected")}: <strong>€ {totalFixedSelectedPriceInterventions}</strong>
        </p>
      </div>
    </div>
  );
};
